import { useEffect, useState } from 'react';

import {
  getUrlToGetAttachmentAudio,
  getUrlToGetAttachmentImage,
  getUrlToGetAttachmentVideo,
} from '../api/Rest/files';
import {
  AttachmentAudio,
  AttachmentImage,
  AttachmentVideo,
  AudioVersion,
  ImageVersion,
  VideoVersion,
} from '../models/Base';

import useInterval from './useInterval';

const fetchUrl = async (
  attachmentType: string,
  contextId: string,
  contextType: string,
  key: string,
  version: string,
): Promise<string | undefined> => {
  if (attachmentType === 'image') {
    const result = await getUrlToGetAttachmentImage(
      { contextType, contextId, key },
      { version },
    );
    if (result.ok) {
      return result.data.url;
    }
  } else if (attachmentType === 'audio') {
    const result = await getUrlToGetAttachmentAudio(
      { contextType, contextId, key },
      { version },
    );
    if (result.ok) {
      return result.data.url;
    }
  } else if (attachmentType === 'video') {
    const result = await getUrlToGetAttachmentVideo(
      { contextType, contextId, key },
      { version },
    );
    if (result.ok) {
      return result.data.url;
    }
  }
  return undefined;
};

type HookType = {
  (
    attachment: AttachmentImage | null | undefined,
    version: ImageVersion,
  ): string | undefined;
  (
    attachment: AttachmentAudio | null | undefined,
    version: AudioVersion,
  ): string | undefined;
  (
    attachment: AttachmentVideo | null | undefined,
    version: VideoVersion,
  ): string | undefined;
};

const usePrivateAttachment: HookType = (
  attachment,
  version,
): string | undefined => {
  const [url, setUrl] = useState<string>();
  const [interval, setInterval] = useState<number>(0);

  useEffect(() => {
    if (
      attachment?.attachmentType &&
      attachment?.contextId &&
      attachment?.contextType &&
      attachment?.key
    ) {
      fetchUrl(
        attachment.attachmentType,
        attachment.contextId,
        attachment.contextType,
        attachment.key,
        version,
      )
        .then((u) => {
          if (u) {
            setUrl(u);
            setInterval(55 * 60 * 1000);
          } else {
            setUrl(undefined);
            setInterval(0);
          }
        })
        .catch((err) => {
          console.error(err);
          setUrl(undefined);
          setInterval(0);
        });
    }

    return () => {
      setUrl(undefined);
      setInterval(0);
    };
  }, [
    attachment?.attachmentType,
    attachment?.contextId,
    attachment?.contextType,
    attachment?.key,
    version,
  ]);

  useInterval(() => {
    if (
      attachment?.attachmentType &&
      attachment?.contextId &&
      attachment?.contextType &&
      attachment?.key
    ) {
      fetchUrl(
        attachment.attachmentType,
        attachment.contextId,
        attachment.contextType,
        attachment.key,
        version,
      )
        .then((u) => {
          if (u) {
            setUrl(u);
          } else {
            setUrl(undefined);
            setInterval(0);
          }
        })
        .catch((err) => {
          console.error(err);
          setUrl(undefined);
          setInterval(0);
        });
    }
  }, interval);

  return url;
};

export default usePrivateAttachment;
